import { IAgentReviewsSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IState } from '../../store';

export const selectAgentReviews = (state: IState) => state.offerData.agentReviews || ({} as IAgentReviewsSchema);
